import { Enum } from "../types";


export function createOptionsList<E extends Enum<E>>(enm: E, obj: { [key in E as string]: string | number }) {

	const options = Object.entries(enm).map(([key, value]) => ({ id: key, value: obj[value] })).filter(v => !!v.value);

	return options
}